// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"multiSearchInput_inputLabel__78Xx4","inputButton":"multiSearchInput_inputButton__5kStZ"};